import dynamic from 'next/dynamic';

import type { LinksBlockSectionProps } from '../../../components/sections/LinksBlockSection';
import type { SectionRenderer } from '../../../types/Section';
import type { Transformer } from '../../../types/Transformer';
import type { LinksBlockSectionContent } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<LinksBlockSectionProps> = dynamic<LinksBlockSectionProps>(
  () =>
    import('../../../components/sections/LinksBlockSection').then((mod) => mod.LinksBlockSection),
);

export const transformer: Transformer<LinksBlockSectionContent, LinksBlockSectionProps> = ({
  _metadata,
  heading,
  sub_heading,
  image,
  background_colour,
  link_groups,
  tracking_title,
}) => {
  return {
    uid: _metadata.uid,
    props: {
      title: heading,
      subHeading: sub_heading,
      imageUrl: image.image_source.url,
      imageAlt: image.alt_text,
      backgroundColor: background_colour,
      linkGroups: link_groups.map(({ title, links }) => {
        return {
          title,
          links: links.map(({ title, href }) => {
            return {
              text: title,
              href,
            };
          }),
        };
      }),
      trackingTitle: tracking_title,
    },
  };
};
